import React from 'react';
import {
  Snackbar,
  Alert,
  AlertTitle,
  Slide,
  SlideProps,
} from '@mui/material';
import { motion } from 'framer-motion';

export interface SnackbarMessage {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  autoHideDuration?: number;
}

interface CustomSnackbarProps {
  snackbar: SnackbarMessage;
  onClose: () => void;
}

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

export const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  snackbar,
  onClose,
}) => {
  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={snackbar.autoHideDuration || 6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      TransitionComponent={SlideTransition}
      sx={{
        '& .MuiSnackbarContent-root': {
          minWidth: '300px',
        },
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8, y: 50 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.8, y: 50 }}
        transition={{ duration: 0.3 }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{
            width: '100%',
            borderRadius: 2,
            boxShadow: 3,
            '& .MuiAlert-icon': {
              alignItems: 'center',
            },
          }}
        >
          {snackbar.title && (
            <AlertTitle sx={{ fontWeight: 600 }}>
              {snackbar.title}
            </AlertTitle>
          )}
          {snackbar.message}
        </Alert>
      </motion.div>
    </Snackbar>
  );
};

export default CustomSnackbar;
